export default __webpack_public_path__ + "static/media/info.c2e066e8.svg";